<template>
  <div class="staff-menu" v-if="showPage">
      <div class="menu-background"> </div>
      
          <div class="menu-content">
              <!-- 个人资料卡片 -->
              <div class="menu-top">
                  <div class="avatar">
                      <div class="avatar-background">
                        <!-- <van-image round width="70px" height="70px" :src="imgSrc" /> -->
                        <van-image round width="70px" height="70px" alt="头像" src="/static/user_avatar.jpg" />
                      </div>
                  </div>
                  <div class="name">{{name}}</div>
                  <div class="place">服务区域: {{place}}</div>
                  <!-- <van-field v-model="region" label="服务区域" readonly autosize type="textarea"/> -->
              </div>

              <!-- 宫格 -->
              <div class="menu">
            
                <van-grid :column-num="2" gutter="25px">
                    <van-grid-item class="menu_item" v-for="item,index in items" :key="index" icon="photo-o" text="文字">
                        <template #default>
                            <van-badge v-if="item.text=='消息推送'" :content="msgNum==0?null:msgNum" max="99">
                                <div class="menu_item_bg" :style='{background:item.color}' @click="golink(item.link)">  
                                    <div class="menu_title">{{item.text}}</div>
                                    <div class="menu_icon"><van-icon color="#fff" :name="item.icon" size="32"/></div>
                                </div>
                            </van-badge>
                            <div v-else class="menu_item_bg" :style='{background:item.color}' @click="golink(item.link)">  
                                <div class="menu_title">{{item.text}}</div>
                                <div class="menu_icon" v-if="item.text=='用药回访'"><img color="#fff" src="../../assets/publicWelfareStaff/method-draw-image.svg" width="32px" height="32px"/></div>
                                <div class="menu_icon" v-else><van-icon color="#fff" :name="item.icon" size="32"/></div>
                            </div>
                        </template>
                    </van-grid-item>
                </van-grid>
              </div>
          </div>

  </div>
</template>

<script>
import { Grid,  GridItem, Badge } from 'vant';
import { getVolunteerInfo } from '@/api/publicWelfareStaff';
import { mapState } from "vuex";
import { Toast } from "vant";
import axios from "axios";

Vue.use(Toast);
import Vue from 'vue';
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Badge)
export default {
    data() {
        return{
            showPage:false,
            name:'',
            place:'',

            items:[
                {text: '患者管理',color: '#EF8868',icon: 'friends-o',link:'patientManage'},
                {text: '消息推送',color: '#65C8F6',icon: 'chat-o',link:'newsFeed'},
                {text: '患者服务',color: '#6EE1B7',icon: 'friends-o',link:'patientServices'},
                {text: '医护拜访',color: '#F8D447',icon: 'like-o',link:'medicalVisit'},
                {text: '监督发药',color: '#A281E1',icon: 'eye-o',link:'superviseDrugDistribution'},
                {text: '盘点库存',color: '#E57B9A',icon: 'bar-chart-o',link:'inventoryCheck'},
                {text: '用药回访',color: '#EF8868',icon: 'revoke',link:'returnVisit'},
                {text: '服务记录',color: '#65C8F6',icon: 'records',link:'serviceRecord'},
                {text: '个人中心',color: '#6EE1B7',icon: 'user-circle-o',link:'personalCenter'},
            ],
            msgNum:0,
        }
    },
    computed: {
        ...mapState(['publicWelfareStaff','userInfo']),
    },
    async created() {
        let stop=false
        await axios.get("oauth/get-current-user").then((res) => {
          if (res.data.volunteer) {
            this.$store.commit("setUserInfo", { userInfo: res.data });
            this.$store.commit("setCheckin_info", res.data.volunteer);
          }else{
            stop=true
            this.$store.commit("clearPublicWelfareStaff");
            this.$router.replace({name:'staffCheckin'})
          }
        })
        if(stop) return
        this.showPage=true
        await getVolunteerInfo({
            volunteer_id:this.userInfo.volunteer.papid
        }).then(res=>{
            if(res.data){
                const {
                    city,
                    messageCount,
                    statusing_list,
                    volunteer
                }=res.data
                console.log("getVolunteerInfo",res)
                this.$store.commit("setVolunteer_info", res.data);
                if(volunteer) this.name=volunteer.name
                if(city) {
                    let str=''
                    city.forEach(ele=>{ str=str+'、'+ele})
                    this.place=str.slice(1)
                }
                if(messageCount) this.msgNum=messageCount
            }
        }).catch(err=>{
            Toast(err.response.data.message)
        })
    },
    methods: {
        golink(routeName){
            if(routeName) this.$router.push({name:routeName})
        }
    }
}
</script>

<style lang="scss" scoped>
.staff-menu{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    // padding-top: 20px;
    .menu-background{
        height: 25vh;
        background:#0AA8AF;
    }
    .menu-content{
        margin-top: -15vh;
        padding-bottom: 5vh;
        .menu-top{
            font-size: 16px;
            margin:0 25px 40px 25px;
            padding: 20px;
            min-height: 20vh;
            line-height: 20px;
            border-radius: 10px;
            // text-align: center;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            
            background: white;
            .avatar{
                margin:-50px 0 0 0;
                text-align: center;
                
                display: flex;
                justify-content:center;
                align-items:center;
                .avatar-background{
                    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                    padding: 3px;
                    border-radius:100%;
                    background: #F9F9F9 ;
                    
                    display: flex;
                    justify-content:center;
                    align-items:center;
                }
            }
            .name{
                color: #898988;
                margin: 10px 0 20px 0;
                text-align: center;
            }
            .place{
                color: #898988;
            }
        }
        .menu{
            .menu_item{
                ::v-deep .van-grid-item__content {
                    padding:0;
                    border-radius: 6px;
                }
                /deep/ .van-grid-item__content--surround::after {
                    border-width:0 !important;
                }
                .van-badge__wrapper{
                    width:100%;
                }
                .menu_item_bg{
                    width:100%;
                    background:#0AA8AF;
                    padding: 10px 8px;
                    border-radius:6px;
                    box-shadow: 2px 2px 8px 5px rgba(0,0,0,0.05);
                    .menu_title{
                        font-size: 16px;
                        color:#fff;
                        text-align: right;
                        margin-bottom: 5px;
                    }
                    .menu_icon{
                        margin-left: 5px;
                    }
                }
                
            }
        }
    }
}
</style>